module.exports = __webpack_public_path__ + "media/images/pc/visit_reservations_enpou/main_visual_nara-05d71e62e52d5e5d838d43783a455860.jpg";